/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AddressStructured,
    AddressStructuredFromJSON,
    AddressStructuredFromJSONTyped,
    AddressStructuredToJSON,
    Task,
    TaskFromJSON,
    TaskFromJSONTyped,
    TaskToJSON,
} from './';

/**
 * 
 * @export
 * @interface BackendApiApiV2ActualVehicleStateVehicleTransportNextWayPoint
 */
export interface BackendApiApiV2ActualVehicleStateVehicleTransportNextWayPoint {
    /**
     * 
     * @type {number}
     * @memberof BackendApiApiV2ActualVehicleStateVehicleTransportNextWayPoint
     */
    lat?: number;
    /**
     * 
     * @type {number}
     * @memberof BackendApiApiV2ActualVehicleStateVehicleTransportNextWayPoint
     */
    lon?: number;
    /**
     * 
     * @type {string}
     * @memberof BackendApiApiV2ActualVehicleStateVehicleTransportNextWayPoint
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof BackendApiApiV2ActualVehicleStateVehicleTransportNextWayPoint
     */
    rta?: string;
    /**
     * 
     * @type {string}
     * @memberof BackendApiApiV2ActualVehicleStateVehicleTransportNextWayPoint
     */
    eta?: string;
    /**
     * 
     * @type {number}
     * @memberof BackendApiApiV2ActualVehicleStateVehicleTransportNextWayPoint
     */
    estimatedDistance?: number;
    /**
     * 
     * @type {number}
     * @memberof BackendApiApiV2ActualVehicleStateVehicleTransportNextWayPoint
     */
    remainingDistancePercentage?: number;
    /**
     * 
     * @type {Array<AddressStructured>}
     * @memberof BackendApiApiV2ActualVehicleStateVehicleTransportNextWayPoint
     */
    addressStructured?: Array<AddressStructured>;
    /**
     * 
     * @type {Array<Task>}
     * @memberof BackendApiApiV2ActualVehicleStateVehicleTransportNextWayPoint
     */
    tasks?: Array<Task>;
    /**
     * 
     * @type {boolean}
     * @memberof BackendApiApiV2ActualVehicleStateVehicleTransportNextWayPoint
     */
    last?: boolean;
}

export function BackendApiApiV2ActualVehicleStateVehicleTransportNextWayPointFromJSON(json: any): BackendApiApiV2ActualVehicleStateVehicleTransportNextWayPoint {
    return BackendApiApiV2ActualVehicleStateVehicleTransportNextWayPointFromJSONTyped(json, false);
}

export function BackendApiApiV2ActualVehicleStateVehicleTransportNextWayPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): BackendApiApiV2ActualVehicleStateVehicleTransportNextWayPoint {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lat': !exists(json, 'lat') ? undefined : json['lat'],
        'lon': !exists(json, 'lon') ? undefined : json['lon'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'rta': !exists(json, 'rta') ? undefined : json['rta'],
        'eta': !exists(json, 'eta') ? undefined : json['eta'],
        'estimatedDistance': !exists(json, 'estimatedDistance') ? undefined : json['estimatedDistance'],
        'remainingDistancePercentage': !exists(json, 'remainingDistancePercentage') ? undefined : json['remainingDistancePercentage'],
        'addressStructured': !exists(json, 'addressStructured') ? undefined : ((json['addressStructured'] as Array<any>).map(AddressStructuredFromJSON)),
        'tasks': !exists(json, 'tasks') ? undefined : ((json['tasks'] as Array<any>).map(TaskFromJSON)),
        'last': !exists(json, 'last') ? undefined : json['last'],
    };
}

export function BackendApiApiV2ActualVehicleStateVehicleTransportNextWayPointToJSON(value?: BackendApiApiV2ActualVehicleStateVehicleTransportNextWayPoint | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lat': value.lat,
        'lon': value.lon,
        'name': value.name,
        'rta': value.rta,
        'eta': value.eta,
        'estimatedDistance': value.estimatedDistance,
        'remainingDistancePercentage': value.remainingDistancePercentage,
        'addressStructured': value.addressStructured === undefined ? undefined : ((value.addressStructured as Array<any>).map(AddressStructuredToJSON)),
        'tasks': value.tasks === undefined ? undefined : ((value.tasks as Array<any>).map(TaskToJSON)),
        'last': value.last,
    };
}


